/**
=========================================================
* Otis Admin PRO - v2.0.2
=========================================================

* Product Page: https://material-ui.com/store/items/otis-admin-pro-material-dashboard-react/
* Copyright 2024 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

/** 
  All of the routes for the Otis Admin PRO React are added here,
  You can add a new route, customize the routes and delete the routes here.

  Once you add a new route on this file it will be visible automatically on
  the Sidenav.

  For adding a new route you can follow the existing routes in the routes array.
  1. The `type` key with the `collapse` value is used for a route.
  2. The `type` key with the `title` value is used for a title inside the Sidenav. 
  3. The `type` key with the `divider` value is used for a divider between Sidenav items.
  4. The `name` key is used for the name of the route on the Sidenav.
  5. The `key` key is used for the key of the route (It will help you with the key prop inside a loop).
  6. The `icon` key is used for the icon of the route on the Sidenav, you have to add a node.
  7. The `collapse` key is used for making a collapsible item on the Sidenav that contains other routes
  inside (nested routes), you need to pass the nested routes inside an array as a value for the `collapse` key.
  8. The `route` key is used to store the route location which is used for the react router.
  9. The `href` key is used to store the external links location.
  10. The `title` key is only for the item with the type of `title` and its used for the title text on the Sidenav.
  10. The `component` key is used to store the component of its route.
*/

// Otis Admin PRO React layouts
import Analytics from "layouts/dashboards/analytics";
import ProfileOverview from "layouts/pages/profile/profile-overview";
import Settings from "layouts/pages/account/settings";
import SignInBasic from "layouts/authentication/sign-in/basic";

// @mui icons
import Icon from "@mui/material/Icon";

// Images
import CreateEvent from "layouts/events/create";

import MapCreateEvent from "layouts/events/create/components/MapCreateEvent";
import TrajectoriesAnalytics from "layouts/trajectories";
import Dates from "layouts/trajectories/steps/Dates";
import Times from "layouts/trajectories/steps/Times";
import Link from "layouts/trajectories/steps/Link";
import Summary from "layouts/trajectories/steps/Summary";
import MapPreviewEvent from "layouts/events/create/components/MapPreviewEvent";
import Results from "layouts/trajectories/results/Results";
import AuthWrapper from "authentication/AuthWrapper";
import ToolLayout from "layouts/tool";
import TrafficMonitoring from "layouts/trafficmonitoring/monitoring";
import IntersectionMonitoring from "layouts/trafficmonitoring/intersection";
import LandingLayout from "layouts/landing";
import RouteFlows from "layouts/trafficmonitoring/routeFlows";
import MFD from "layouts/trafficmonitoring/mfd";
import CreateNotification from "layouts/notifications/create";
import CreateSumo from "layouts/sumo/create";
import LibrarySumo from "layouts/sumo/library";
import Events from "layouts/dataimport/events";
import Interventions from "layouts/dataimport/interventions";
import Accidents from "layouts/dataimport/accidents";
import MapPage from "layouts/map";
import Cluster from "layouts/cluster";
import ShowAccidentList from "layouts/dataview/accidents";
import AccidentDetails from "layouts/dataview/accidents/details";
import AccidentEdit from "layouts/dataview/accidents/edit";
import ShowInterventionList from "layouts/dataview/interventions";
import GeneralStatistics from "layouts/dashboards/road-safety/general/GeneralStatistics";
import InterventionFormReadOnly from "layouts/dataview/interventions/details";
import InterventionEdit from "layouts/dataview/interventions/edit";
import RatioDashboard from "layouts/dashboards/road-safety/ratio/RatioDashboard";
import CompareDashboard from "layouts/dashboards/road-safety/compare/CompareDashboard";
import ComparisonDashboard from "layouts/dashboards/road-safety/comparison/ComparisonDashboard";
import ElstatInputsForm from "layouts/dataimport/elastat/ElastatInputForm";
import TrafficPage from "layouts/traffic/TrafficPage";
import Charts from "layouts/pages/charts";

const routes = [
  // nav link
  // {
  //   type: "collapse",
  //   name: "Test",
  //   key: "test",
  //   icon: <Icon fontSize="medium">Test</Icon>,
  //   collapse: [
  //     {
  //       name: "Mapbox",
  //       key: "Mapbox",
  //       route: "/events/mapbox",
  //       component: <Mapbox />,
  //     },
  //     {
  //       name: "Deck",
  //       key: "Deck",
  //       route: "/events/deck",
  //       component: <Deck />,
  //     },
  //   ],
  // },
  // {
  //   type: "single",
  //   name: "Data Quality",
  //   key: "quality",
  //   icon: <Icon fontSize="medium">storage</Icon>,
  //   route: "/dashboards/dataquality",
  //   component: <DataQualityLayout />,
  //   noCollapse: true,
  // },
  // {
  //   type: "single",
  //   name: "Στατιστικά",
  //   key: "stats",
  //   icon: <Icon fontSize="medium">percentage</Icon>,
  //   route: "/dashboards/analytics-old",
  //   component: <AuthWrapper><Analytics /></AuthWrapper>,
  //   noCollapse: true,
  // },
  {
    type: "collapse",
    name: "Στατιστικά",
    key: "stats-new-group",
    icon: <Icon fontSize="medium">percentage</Icon>,
    collapse: [
      {
        name: "Βασικοί αριθμοί",
        key: "stats-new-analytics",
        route: "/dashboards/analytics",
        component: <AuthWrapper><GeneralStatistics /></AuthWrapper>,
      },
      {
        name: "Λόγοι",
        key: "stats-new-ratio",
        route: "/dashboards/analytics-ratio",
        component: <RatioDashboard />,
      },
      {
        name: "Συγκρίσεις μεταξύ ετών",
        key: "stats-new-comare",
        route: "/dashboards/analytics-compare",
        component: <CompareDashboard />,
      },
      {
        name: "Μέσοι Όροι",
        key: "stats-new-comparison",
        route: "/dashboards/analytics-comparison",
        component: <ComparisonDashboard />,
      },

      
    ],
  },
  {
    type: "collapse",
    name: "Εισαγωγή Δεδομένων",
    key: "dataimport",
    icon: <Icon fontSize="medium">input</Icon>,
    collapse: [
      {
        name: "Συμβάντα",
        key: "events",
        route: "/import/events",
        component: <Events />
      },
      {
        name: "Παρεμβάσεις",
        key: "interventions",
        route: "/import/interventions",
        component: <Interventions />
      },
      {
        name: "Ατυχήματα",
        key: "accidents",
        route: "/import/accidents",
        component: <Accidents />,
      },
                  {
        name: "Δεδομένα ΕΛΣΤΑΤ",
        key: "stats-input-elstat",
        route: "/import/elstat",
        component: <ElstatInputsForm />,
      },
    ],
  },
  {
    type: "collapse",
    name: "Προβολή Δεδομένων",
    key: "dataview",
    icon: <Icon fontSize="medium">storage</Icon>,
    collapse: [
      {
        name: "Παρεμβάσεις",
        key: "interventions",
        route: "/list/interventions",
        component: <ShowInterventionList />
      },
      {
        name: "Ατυχήματα",
        key: "accidents",
        route: "/list/accidents",
        component: <ShowAccidentList />,
      },
    ],
  },
  {
    type: "single",
    name: "Χάρτης",
    key: "map",
    icon: <Icon fontSize="medium">public</Icon>,
    route: "/map",
    component: <MapPage />,
    noCollapse: true,
  },


  {
    type: "single",
    name: "Cluster",
    key: "cluster",
    icon: <Icon fontSize="medium">bubble_chart</Icon>,
    route: "/cluster",
    component: <Cluster />,
    noCollapse: true,
  }, 
      {
    type: "single",
    name: "Living lab",
    key: "livinglab",
    icon: <Icon fontSize="medium">insert_chart</Icon>,
    href: "https://traffic-rhodes.imet.gr/coloredpathsviewer.aspx",
    noCollapse: true,

  },
    {
    type: "single",
    name: "Traffic",
    key: "traffic",
    icon: <Icon fontSize="medium">monitoring</Icon>,
    route: "/traffic",
    component: <TrafficPage />,
    noCollapse: true,
  },

  { type: "divider", key: "divider-0" },
    // settings
    {
    type: "single",
    name: "Logout",
    key: "logout",
    route: "/authentication/sign-in/basic",
    icon: <Icon fontSize="medium">manage_accounts</Icon>,
    noCollapse: true,
    component: <SignInBasic />,
    },

  // just links
  {
    route: "/landing",
    key: "landingPage",
    component: <AuthWrapper><LandingLayout /></AuthWrapper>,
  },
  {
    route: "/list/accidents/:id",
    key: "detailedAccident",
    component: <AuthWrapper><AccidentDetails /></AuthWrapper>,
  },
    {
    route: "/list/accidents/:id/edit",
    key: "editAccident",
    component: <AuthWrapper><AccidentEdit /></AuthWrapper>,
  },
  {
    route: "/list/interventions/:id",
    key: "detailedIntervention",
    component: <AuthWrapper><InterventionFormReadOnly /></AuthWrapper>,
  },
  {
    route: "/list/interventions/:id/edit",
    key: "editIntervention",
    component: <AuthWrapper><InterventionEdit /></AuthWrapper>,
  },
  {
    route: "/events/create/map-create-event",
    key: "mapCreateEvent",
    component: <MapCreateEvent />,
  },
  {
    route: "/events/map-preview-event",
    key: "mapPreviewEvent",
    component: <MapPreviewEvent />,
  },
  {
    route: "/trajectories/dates",
    key: "dates",
    component: <Dates />,
  },
  {
    route: "/trajectories/times",
    key: "times",
    component: <Times />,
  },
  {
    route: "/trajectories/link",
    key: "link",
    component: <Link />,
    roles: ["super", "editor", "thessaloniki", "madrid"],
  },
  {
    route: "/trajectories/summary",
    key: "summary",
    component: <Summary />,
  },
  {
    route: "/trajectories/result",
    key: "result",
    component: <Results />,
  },
];

export default routes;
